import { PhoneNumberType } from 'app/generated/backend/types/phone-number-type';
export class PhoneNumberLookupResult {
	id: number;
	updatedUserId: number;
	updatedAt: string;
	countryId: number;
	number: string;
	type: PhoneNumberType;
}
